<div class="company-profile mb-footer">
    <!-- section 1 -->
    <div class="sec-1">
        <div class="container">
            <div class="row">
                <!-- section title -->
                <div class="col-md-12 my-md-5 mb-5 sec-title">
                    <app-title-page [dataTitle]="dataTitle" [link]="'#good-green'"></app-title-page>
                </div>
                <!-- section 1 contents -->
                <div class="col-md-12" id="good-green">
                    <div class="sec1-title f-tit pb-3" [innerHTML]="dataSection[0]?.title"></div>
                    <div class="desc py-4 text-justify" [innerHTML]="dataSection[0]?.content"></div>
                    <div class="sec1-picture" [ngStyle]="{'background-image' : 'url('+ apiAsset + dataSection[0]?.picture +')'}"></div>
                    <div class="row sec1-thumbnail flag my-5">
                        <div class="col-md-6 order-md-1 order-2 pl-xl-5 py-xl-5 pr-xl-4 p-4">
                            <h4 class="f-subtit fw-400 mb-4">{{ dataSection[1]?.title }}</h4>
                            <div class="desc text-justify" [innerHTML]="dataSection[1]?.content"></div>
                        </div>
                        <div class="col-md-6 order-md-2 order-1 pl-xl-3 px-0">
                            <img class=" w-100" [src]="apiAsset + dataSection[1]?.picture" alt="">
                        </div>
                    </div>
                    <div class="row sec1-thumbnail">
                        <div class="col-md-6 mb-md-0 mb-4">
                            <img class="w-100" [src]="apiAsset + dataSection[2]?.picture" alt="">
                        </div>
                        <div class="col-md-6 pl-xl-4">
                            <h4 class="f-subtit fw-400 mb-4">{{ dataSection[2]?.title }}</h4>
                            <div class="desc text-justify" [innerHTML]="dataSection[2]?.content"></div>
                        </div>
                    </div>
                    <div class="sec1-detail-2 mt-5">
                        <h4 class="f-subtit fw-400 headline">{{ dataSection[3]?.title }}</h4>
                        <div class="desc mt-4 text-justify" [innerHTML]="dataSection[3]?.content"></div>
                    </div>
                </div>
            </div>
        </div>    
    </div>
    <!-- section 2 contents -->
    <div class="sec-2 my-5">
        <div class="container bg-absolute d-md-block d-none">
            <div class="row">
                <div class="col-md-6 pr-4">
                    <h3 class="fw-500">{{ dataSection[4]?.title }}</h3>
                </div>
            </div>
        </div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-6 py-md-0 py-5 bg-red">
                    <h3 class="fw-500 d-md-none d-block">{{ dataSection[4]?.title }}</h3>
                </div>
                <div class="col-md-6 bg-picture d-md-block d-none"
                    [ngStyle]="{'background-image' : 'url('+ apiAsset + dataSection[4]?.picture +')'}">
                </div>
            </div>
        </div>
    </div>
     <!-- section 3 contents -->
     <div class="sec-3">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-xl-9 col-lg-8 col-md-7">
                            <div class="desc text-justify" [innerHTML]="dataSection[4]?.content"></div>
                        </div>
                        <div class="col-xl-3 col-lg-4 col-md-5 col-sm-7 col-9 mt-md-0 mt-4 mx-auto">
                            <a  target="_blank" 
                                href="http://www.binasawitmakmur.com/" 
                                class="btn red-btn-icon w-100">
                                PT Binasawit Makmur
                                <img class="ic-arr" src="../../../../assets/images/icon/arrow-left-white.svg" alt="">
                            </a>
                            <a routerLink="/our-products/dxp-sriwijaya" class="mt-2 btn red-btn-icon w-100">
                                DxP Sriwijaya 
                                <img class="ic-arr" src="../../../../assets/images/icon/arrow-left-white.svg" alt="">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

